import { IntlShape } from 'react-intl'
import { ItemPriceRange } from 'typings'
import { create, enforce, omitWhen, test } from 'vest'
import { messages } from './messages'

export function validationSuite(intl: IntlShape) {
  return create(({ min, max }: Partial<ItemPriceRange>) => {
    const { formatMessage: i18n } = intl
    const { validation } = messages

    const minEmpty = min === undefined
    const maxEmpty = max === undefined

    omitWhen(minEmpty, () => {
      test('min', i18n(validation.greaterThan, { value: 0 }), () => {
        enforce(min).greaterThan(0)
      })
    })

    omitWhen(minEmpty || maxEmpty, () => {
      test('min', i18n(validation.minGreaterThanEqualsMax), () => {
        enforce(min).lessThanOrEquals(max)
      })

      test('max', i18n(validation.maxLowerThanEqualsMin), () => {
        enforce(max).greaterThanOrEquals(min)
      })
    })

    omitWhen(maxEmpty, () => {
      test('max', i18n(validation.greaterThan, { value: 0 }), () => {
        enforce(max).greaterThan(0)
      })
    })
  })
}
